import React from "react";

export function stockStatus(qty, threshold) {
  const q = Number(qty || 0);
  const t = Number(threshold || 0);
  if (q <= 0) return "esaurito";
  if (q <= t) return "in_esaurimento";
  return "ok";
}

export default function StatusBadge({ quantity, threshold }) {
  const s = stockStatus(quantity, threshold);
  if (s === "esaurito") {
    return (
      <span className="pill pill-danger" data-testid="status-badge-esaurito">
        Esaurito
      </span>
    );
  }
  if (s === "in_esaurimento") {
    return (
      <span
        className="pill pill-warn"
        data-testid="status-badge-in-esaurimento"
      >
        In esaurimento
      </span>
    );
  }
  return (
    <span className="pill pill-ok" data-testid="status-badge-ok">
      OK
    </span>
  );
}
